import { $API } from "boot/api";

/**
 * Fetch excluded tags for a specific license
 */
export async function fetchExcludedTags({ commit }, licenseId) {
  try {
    const response = await $API.EXCLUDED_PACKAGES.GET({
      license_id: licenseId,
      tags_only: true,
    });
    commit("setExcludedTags", {
      licenseId,
      tags: response.data.tags || [],
    });
    return response.data.tags || [];
  } catch (error) {
    console.error("Failed to fetch excluded tags:", error);
    return [];
  }
}

/**
 * Fetch all excluded packages for the management page
 */
export async function fetchExcludedPackages({ commit }, params = {}) {
  commit("setLoading", true);
  try {
    const response = await $API.EXCLUDED_PACKAGES.GET(params);
    commit("setExcludedPackages", response.data.data || []);
    return response.data.data || [];
  } catch (error) {
    console.error("Failed to fetch excluded packages:", error);
    return [];
  } finally {
    commit("setLoading", false);
  }
}

/**
 * Toggle exclusion status for a package
 */
export async function toggleExclusion({ commit, state }, { licenseId, tag }) {
  const isCurrentlyExcluded = state.excludedTags[licenseId]?.includes(tag);

  try {
    const response = await $API.EXCLUDED_PACKAGES.POST("toggle", {
      license_id: licenseId,
      tag,
    });

    if (isCurrentlyExcluded) {
      commit("removeExcludedTag", { licenseId, tag });
    } else {
      commit("addExcludedTag", { licenseId, tag });
    }

    return response.data;
  } catch (error) {
    console.error("Failed to toggle exclusion:", error);
    throw error;
  }
}
